<script lang="ts" setup>
  import type { TypeSpacerComponent } from '@/types/contentful'

  defineProps<{
    data: TypeSpacerComponent<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <CSpacer :background-color="data.fields.base?.fields.backgroundColour" :size="data.fields.size" />
</template>
